export default function getSecret(key) {
  return process.env['VUE_APP_'+key] || process.env[key.toUpperCase()];
}